import React from "react";
import { Navigate } from "react-router-dom";
import UserTypeRoute from "./UserTypeRoute";
import BloodPressureCollection from "../pages/Annotator/BloodPressureCollection";


// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import OAuthCallbackPage from "pages/Authentication/OauthCallbackPage";

//Crypto
import Dashboard from "../pages/Dashboard/dashboard";

import Faqs from "pages/Faqs/faqs";

const authProtectedRoutes = [
  { 
    path: "/dashboard", 
    component: (
      <UserTypeRoute allowedTypes={['DataCollector']}>
        <Dashboard />
      </UserTypeRoute>
    )
  },
  { 
    path: "/blood-pressure", 
    component: (
      <UserTypeRoute allowedTypes={['Annotator']}>
        <BloodPressureCollection />
      </UserTypeRoute>
    )
  },
  { 
    path: "/how-to", 
    component: (
      <UserTypeRoute allowedTypes={['DataCollector']}>
        <Faqs />
      </UserTypeRoute>
    )
  },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  
];
const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/register", component: <Register /> },
  { path: "/oauth/callback", component: <OAuthCallbackPage /> }

];

export { authProtectedRoutes, publicRoutes };
